import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { loadIfStateAvailableInSessionStorage, savePageStateInSessionStorage } from '../../../../utils';
// restClient
import { eapiClient, aemHostClient } from '../../../../restClient';
// children
import MultiLineSelect from '../../../common/MultiLineSelect';
import PersistLink from '../../../common/PersistLink';
import Radiobutton from '../../../common/Radio/radioButton';
//action Creator
import { setPersons } from '../../actions/actionCreator';

class AustraliaAuthorisedForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noOfpaymentAuthorisers: 1,
      countryAustraliaForm: {
        signatories: [],
        authorisedRefreeForm: [],
        paymentAuthoriserSignatories: []
      },
      id: '',
      lid: '',
      dataReady: false,
      methodFlag: false
    };
  }

  loadPageState = () => {
    var { caseId, productId } = this.props.match.params;
    eapiClient("/countryForms/case/" + caseId + "/country/Australia")
      .then(({ data }) => {
        this.setState({
          countryAustraliaForm: {
            ...this.state.countryAustraliaForm,
            signatories: data.responseData
          }
        });

        eapiClient("/countryForms/case/" + caseId + "/product/" + productId)
          .then(({ data }) => {
            this.setState({ entityName: data.responseData.entityName })
            if (data.responseData.countryAustraliaForm !== undefined) {
              this.setState({
                countryAustraliaForm: {
                  ...this.state.countryAustraliaForm,
                  authorisedRefreeForm: data.responseData.countryAustraliaForm.authorisedRefreeForm
                }, methodFlag: true
              });

              if (data.responseData.countryAustraliaForm.paymentAuthoriserSignatories !== undefined) {
                this.setState({
                  countryAustraliaForm: {
                    ...this.state.countryAustraliaForm,
                    paymentAuthoriserSignatories: data.responseData.countryAustraliaForm.paymentAuthoriserSignatories
                  }
                });
              }

              const _paymentAuthoriserSignatoriesGet = data.responseData.countryAustraliaForm.paymentAuthoriserSignatories;
              if (_paymentAuthoriserSignatoriesGet && _paymentAuthoriserSignatoriesGet.length > 0 && this.state.noOfpaymentAuthorisers !== _paymentAuthoriserSignatoriesGet.length) {
                this.setState({ noOfpaymentAuthorisers: _paymentAuthoriserSignatoriesGet.length });
              }

              let _authorisedRefreeForm = [];
              const { authorisedRefreeForm, signatories } = this.state.countryAustraliaForm;
              authorisedRefreeForm.forEach(authorisedRefreeFormData => {
                _authorisedRefreeForm[signatories.findIndex(signatory => signatory.id === authorisedRefreeFormData.signatoryId)] = authorisedRefreeFormData;
              });
              this.setState({
                countryAustraliaForm: { ...this.state.countryAustraliaForm, authorisedRefreeForm: _authorisedRefreeForm },
                dataReady: true
              });

            }
            else {
              this.setState({
                id: data.responseData.id, lid: data.responseData.lid,
                dataReady: true
              });
            }
          });
      });
  }

  componentWillMount() {
    var { caseId } = this.props.match.params;
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });

    let apiURL = "/aemData/formData/json_australia-authorised-referee-page";

    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("json_add-", "json_edit-");
    }

    aemHostClient(apiURL)
      .then(({ data }) => {
        this.setState({ formJson: data });
      });

    aemHostClient("/aemData/formData/json_country-form-page")
      .then(({ data }) => {
        this.setState({ pageJson: data });
      });

    eapiClient("/persons/case/" + caseId)
      .then(({ data }) => {
        this.props.setPersons(data.responseData);
      });
  }


  onFormSubmit = (event, apiURL) => {

  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  setAuthorised = (value, name) => {
    this.setState({ previouslySignedAuthorisedRefereeForm: value });
  }

  setFormData = (index, signatoryId, id, event) => {
    let _authorisedRefreeForm = [...this.state.countryAustraliaForm.authorisedRefreeForm];
    const previouslySignedAuthorisedRefereeForm = event.target.value;
    if (id === undefined) {
      _authorisedRefreeForm[index] = { previouslySignedAuthorisedRefereeForm: previouslySignedAuthorisedRefereeForm, signatoryId };
    } else {
      let ids = id.id;
      _authorisedRefreeForm[index] = { previouslySignedAuthorisedRefereeForm: previouslySignedAuthorisedRefereeForm, signatoryId, id: ids };
    }

    this.setState({ countryAustraliaForm: { ...this.state.countryAustraliaForm, authorisedRefreeForm: _authorisedRefreeForm } });
  }


  componentDidMount() {
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);

    if (getCurrentDropDown !== null) {
      var getCurrentDropDownName = getCurrentDropDown.substring(0, getCurrentDropDown.length - 1);
    }
    if (getCurrentDropDownName === 'paymentAuthoriserSignatories') {
      var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length - 1);
    }

    if (getCurrentDropDownName === 'paymentAuthoriserSignatories') {
      if (this.state.countryAustraliaForm.paymentAuthoriserSignatories.length === 0 && getCurrentDropDownValue !== null) {
        var _paymentAuthoriserSignatories = [...this.state.countryAustraliaForm.paymentAuthoriserSignatories];
        _paymentAuthoriserSignatories[0] = getCurrentDropDownValue;
        this.setState({
          countryAustraliaForm: {
            ...this.state.countryAustraliaForm,
            paymentAuthoriserSignatories: _paymentAuthoriserSignatories
          }
        }, () => { });

      }
      this.state.countryAustraliaForm.paymentAuthoriserSignatories.forEach((currentValue, index, arr) => {
        if (currentValue !== getCurrentDropDownValue && index === getCurrentDropDownIndex - 1 && getCurrentDropDownValue !== null) {
          var _paymentAuthoriserSignatories = [...this.state.countryAustraliaForm.paymentAuthoriserSignatories];
          _paymentAuthoriserSignatories[index] = getCurrentDropDownValue;
          this.setState({
            countryAustraliaForm: {
              ...this.state.countryAustraliaForm,
              paymentAuthoriserSignatories: _paymentAuthoriserSignatories
            }
          }, () => { });

        } else if (getCurrentDropDownValue !== null && index !== getCurrentDropDownIndex - 1 && getCurrentDropDownName === 'paymentAuthoriserSignatories') {
          var _paymentAuthoriserSignatories1 = [...this.state.countryAustraliaForm.paymentAuthoriserSignatories];
          _paymentAuthoriserSignatories1[getCurrentDropDownIndex - 1] = getCurrentDropDownValue;
          this.setState({
            countryAustraliaForm: {
              ...this.state.countryAustraliaForm,
              paymentAuthoriserSignatories: _paymentAuthoriserSignatories1
            }
          }, () => { });

        }
      })
    }

    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key' + getCurrentDropDown);
  }

  saveStateToSessionOnEdit = () => {
    savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
  }
  renderFields() {
    let element = [];

    for (let i = 0; this.state.countryAustraliaForm.signatories.length > i; i++) {
      element.push(<div className="gdocs-constent-wraper">
        <span className="gdocs-authorised-person">
          <b>{`${this.state.countryAustraliaForm.signatories[i].firstName}
      ${this.state.countryAustraliaForm.signatories[i].lastName}
      ${this.state.countryAustraliaForm.signatories[i].dateOfBirth !== undefined ? ',' : ''}
      ${this.state.countryAustraliaForm.signatories[i].dateOfBirth !== undefined ?
              this.state.countryAustraliaForm.signatories[i].dateOfBirth : ''}`}</b>
        </span>
        <span className="gdocs-authorised-radio-btn">
          <label className="gdocs-authorised-label">Yes

            <Radiobutton setInputvalue={this.setAuthorised}
              name={`authorisedPerson${i}`}

              _onChange={this.setFormData.bind(this, i, this.state.countryAustraliaForm.signatories[i].id,
                this.state.countryAustraliaForm.authorisedRefreeForm[i])}
              value="true"
              _value={this.state.countryAustraliaForm.authorisedRefreeForm[i] !== undefined ?
                this.state.countryAustraliaForm.authorisedRefreeForm[i].previouslySignedAuthorisedRefereeForm : ''}
            />
          </label>
          <label className="gdocs-authorised-label">No

            <Radiobutton setInputvalue={this.setAuthorised}
              name={`authorisedPerson${i}`}

              _onChange={this.setFormData.bind(this, i, this.state.countryAustraliaForm.signatories[i].id,
                this.state.countryAustraliaForm.authorisedRefreeForm[i])}
              value="false"
              _value={this.state.countryAustraliaForm.authorisedRefreeForm[i] !== undefined ?
                this.state.countryAustraliaForm.authorisedRefreeForm[i].previouslySignedAuthorisedRefereeForm : ''}
            />
          </label>
        </span>
      </div>)
    }
    return element;
  }

  handlePaymentEditClick = (accountSignatory) => {
    var { caseId } = this.props.match.params;
    if (accountSignatory) {
      this.saveStateToSessionOnEdit();
      this.props.history.push("/case-body/country-forms/create-user/" + accountSignatory.id + '/' + caseId);
    }
  }
  handlePaymentAuthoriserfieldsChange = (index, paymentAuthoriserSignatories) => {

    var _paymentAuthoriserSignatories = [...this.state.countryAustraliaForm.paymentAuthoriserSignatories];
    _paymentAuthoriserSignatories[index] = paymentAuthoriserSignatories.id;
    this.setState({
      countryAustraliaForm: {
        ...this.state.countryAustraliaForm,
        paymentAuthoriserSignatories: _paymentAuthoriserSignatories
      }
    }, () => { });
  }

  onAdditionUser = () => {
    this.setState(prevState => {
      return { noOfpaymentAuthorisers: prevState.noOfpaymentAuthorisers + 1 }
    });
  }

  onPaymentAuthoriserSignatoriesDeletion = (index) => {
    let _paymentAuthoriserSignatories = [...this.state.countryAustraliaForm.paymentAuthoriserSignatories];
    _paymentAuthoriserSignatories.splice(index, 1);
    this.setState(prevState => {
      return {
        noOfpaymentAuthorisers: prevState.noOfpaymentAuthorisers - 1,
        countryAustraliaForm: { ...prevState.countryAustraliaForm, paymentAuthoriserSignatories: _paymentAuthoriserSignatories }
      }
    });
  }


  saveForm = () => {
    var payLoad = {};
    var { caseId, productId } = this.props.match.params;
    //countryAustraliaForm.authorisedRefreeForm=this.state.authorisedRefreeForm;
    //countryAustraliaForm.paymentAuthoriserSignatories = this.state.paymentAuthoriserSignatories;
    payLoad.countryAustraliaForm = { ...this.state.countryAustraliaForm };
    payLoad.caseId = caseId;
    payLoad.productId = productId;
    payLoad.id = this.state.id;
    payLoad.lid = this.state.lid;
    payLoad.countryFormName = "Australia authorised form"
    var apiURL;
    // if(this.state.methodFlag){
    //   var METHOD = 'PUT'
    //   apiURL = EAPI_HOST_URI + "/countryForms/case/" + caseId + "/product/" + productId
    // }else {
    //   apiURL="/countryForms/"
    //   var METHOD = 'POST'
    // }
    apiURL = "/countryForms/case/" + caseId + "/product/" + productId;
    eapiClient(apiURL, {
      method: "PUT",
      data: JSON.stringify(payLoad)
    })
      .then(({ data }) => {
      });
    this.props.history.goBack();
  }


  render() {
    let addAuthoriserJsx;
    var { caseId } = this.props.match.params;
    let buttonJsx = (<h3>Loading.....</h3>);
    if (this.state.formJson) {
      buttonJsx = (<div>
        <button onClick={this.saveForm} aria-label={this.state.formJson['sticky-footer-btn2'].text} className="gdocs-btn-submit"> {this.state.formJson['sticky-footer-btn2'].text}</button>
      </div>);
    }
    addAuthoriserJsx = (
      <button className="gdocs-btn-default marg-bottom" onClick={this.onAdditionUser}><i className="icon icon-add"></i> Add authoriser {this.state.noOfpaymentAuthorisers + 1}</button>
    );

    let filteredPerson = [];
    let personArray = this.props.persons;
    let signatoriesArray = this.state.countryAustraliaForm.signatories;
    let filterArray = []
    if (this.state.countryAustraliaForm.signatories !== undefined) {
      personArray.forEach(function (person) {
        filterArray = signatoriesArray.filter(function (signatories) {
          return person.id === signatories.id
        })
        if (filterArray.length === 0) {
          filteredPerson.push(person)
        }
      })

    }

    let paymentAuthoriserjsx = [];
    for (var i = 1; i <= this.state.noOfpaymentAuthorisers; i++) {
      paymentAuthoriserjsx.push(<div className="gdocs-australia-user-form">
        <div className="gdocs-clear-float"></div>
        <div className="gdocs-australia-user-wrapper">
          <div className="gdocs-australia-user-position">Payment authoriser {i}</div>
          <div className="gdocs-australia-user-position">
            {(i > 1) ? <span className="delete-btn" role="button" onClick={this.onPaymentAuthoriserSignatoriesDeletion.bind(this, i - 1)}><i className="icon icon-bin"></i></span> : ''}
            {
              filteredPerson.length > 0 ?
                (<MultiLineSelect defaultValue="Please select"
                  requiredFields={{
                    "row1": ["firstName", "lastName"],
                    "row2": ["dateOfBirth", "countryOfResidence", "nationality"],
                    "row3": []
                  }}
                  data={filteredPerson || []}
                  value={this.state.countryAustraliaForm.paymentAuthoriserSignatories[i - 1] ?
                    this.state.countryAustraliaForm.paymentAuthoriserSignatories[i - 1] : ''}
                  onEdit={this.handlePaymentEditClick} _onChange={this.handlePaymentAuthoriserfieldsChange.bind(this, i - 1)} />
                ) : ''}

            <span className="icon icon-add addicon"></span>
            <PersistLink className="mrg-left"
              history={this.props.history}
              state={this.state}
              to={'/case-body/country-forms/create-user/' + caseId}
              data={`paymentAuthoriserSignatories${i}`}>
              Create new authoriser
            </PersistLink>
          </div>
        </div>
      </div>);
    }
    const pageTitle = this.state.formJson ? this.state.formJson.par.title : {};
    return ((this.state.dataReady) ?
      <div className="form-container">
        <div className="form-title">
          <h1 className="form-heading">{pageTitle.title}</h1>
          <div className="gdocs-clear-float"></div>
          <p className="pannel-sub-heading">{this.state.entityName}</p>
          <p className="form-required-desc optional-text">{pageTitle.description}</p>
        </div>
        <div className="gdocs-clear-float"></div>
        <p className="gdocs-canada-par-text">{this.state.pageJson.par.countryform.ausPreviouslySigned}</p>
        <div className="gdocs-clear-float"></div>
        {this.renderFields()}
        <div className="gdocs-clear-float"></div>
        <div className="gdocs-australia-user-form-wrapper">
          <p className="gdocs-ptop-30">{this.state.pageJson.par.countryform.ausPaymentAuthoriser}</p>
          <p>{this.state.pageJson.par.countryform.ausSystemAdmin}</p>

          {paymentAuthoriserjsx}
          <div className="gdocs-clear-float"></div>
          <div>{addAuthoriserJsx}</div>
        </div>
        <div className="gdocs-clear-float"></div>
        <div key="buttons-wrapper" className="form-buttons-section country-form-buttons-section">
          <div className="form-buttons-wrapper">
            {buttonJsx}
          </div>
        </div>
      </div>
      : '');
  }
}

const mapStateToProps = state => {
  return {
    persons: state.persons
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setPersons: persons => {
      dispatch(setPersons(persons));
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(AustraliaAuthorisedForm);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CountryForms/AustraliaAuthorisedForm.js